import React from 'react'
import { Tooltip as ReactTooltip } from 'react-tooltip'

interface Props {
    id: string
    varient?: 'light' | 'dark'
    delay?: number
    float?: boolean
    noArrow?: boolean
    children: React.ReactNode
}

const Tooltip = ({ id, varient = 'light', delay, float = true, noArrow = true, children }: Props) => {
    return (
        <ReactTooltip id={id} opacity={1} variant={varient} noArrow={noArrow} float={float} delayShow={delay} style={{ maxWidth: 400 }}
            className={`border shadow-sm f-s-14 p-3`}
            children={children} />
    )
}

export default Tooltip